import Button from "@material-ui/core/Button";
import CircularProgress from "@material-ui/core/CircularProgress";
import Grid from "@material-ui/core/Grid";
import MuiLink from "@material-ui/core/Link";
import Paper from "@material-ui/core/Paper";
import withStyles from "@material-ui/core/styles/withStyles";
import Typography from "@material-ui/core/Typography";
import AccountCircleIcon from "@material-ui/icons/AccountCircle";
import FacebookIcon from "@material-ui/icons/Facebook";
import LinkedInIcon from "@material-ui/icons/LinkedIn";
import PropTypes from "prop-types";
import React, { Component } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { getUserData } from "../redux/actions/userActions";


const styles = {
  root: {
    minWidth: "275px",
  },
  center: {
    margin: "auto 1em auto 1em",
    minWidth: "275px",
  },
  containerCentral: {
    justifyContent: "center",
  },
  lightText: {
    fontWeight: "100",
  },
  heading: {
    fontWeight: "800",
    margin: "1em auto 0.5em auto",
    fontSize: "1em",
  },
  nameContainer: {
    justifyContent: "center",
    alignItems: "center",
    verticalAlign: "top",
    textAlign: "center",
  },
  name: {
    margin: "0.5em auto 1em auto",
    display: "block",
    fontSize: "1.5em",
    fontWeight: "800",
  },
  image: {
    height: "3em",
    width: "3em",
    color: "#2a6196",
  },
  button: {
    marginTop: "2em",
    position: "relative",
    width: "100%",
  },
  info: {
    fontSize: "1em",
    margin: "0.5em auto auto auto",
  },
};

export class profile extends Component {
  componentDidMount() {
    this.props.getUserData();
  }

  render() {
    const {
      classes,
      user: {
        name,
        goal,
        school,
        year,
        facebook,
        linkedin,
        loading,
        authenticated,
      },
    } = this.props;

    const preventDefault = (event) => event.preventDefault();

    let profileMarkup = !loading ? (
      authenticated ? (
        <div>
          <div className={classes.nameContainer}>
            <AccountCircleIcon className={classes.image} />
            <br />
            <Typography variant="body2" className={classes.name}>
              {name}
            </Typography>
          </div>
          <Typography variant="body2" className={classes.heading}>
            School
          </Typography>
          <Typography variant="body2" className={classes.info}>
            {school}
          </Typography>
          <Typography variant="body2" className={classes.heading}>
            Year: {year}
          </Typography>
          <Typography variant="body2" className={classes.info}>
            {year}
          </Typography>
          <Typography variant="body2" className={classes.heading}>
            Career goal:
          </Typography>
          <Typography variant="body2" className={classes.info}>
            {goal}
          </Typography>
          <br />

          <div>
            <MuiLink href={linkedin} target="_blank" rel="noopener noreferrer">
              <LinkedInIcon />
            </MuiLink>
            <MuiLink href={facebook} target="_blank" rel="noopener noreferrer">
              <FacebookIcon />
            </MuiLink>
          </div>

          <Button
            className={classes.button}
            component={Link}
            to="/profile/edit"
            variant="contained"
            color="secondary"
          >
            Edit Profile
          </Button>
        </div>
      ) : (
        <Paper className={classes.paper}>
          <Typography variant="body2" aligh="center">
            No profile found, please login again
          </Typography>
          <div className={classes.buttons}>
            <Button
              variant="contained"
              color="primary"
              component={Link}
              to="/login"
            >
              Login
            </Button>
            <Button
              variant="contained"
              color="secondary"
              component={Link}
              to="/signup"
            >
              Signup
            </Button>
          </div>
        </Paper>
      )
    ) : (
      <div style={{ display: "flex", justifyContent: "center" }}>
        <CircularProgress />
      </div>
    );

    return (
      <Grid container className={classes.containerCentral}>
        <Grid item sm />
        <Grid item sm className={classes.center}>
          <Typography variant="h3">My Profile</Typography>
          <br />
          {profileMarkup}
        </Grid>
        <Grid item sm />
      </Grid>
    );
  }
}

profile.propTypes = {
  user: PropTypes.object.isRequired,
  classes: PropTypes.object.isRequired,
};

const mapActionsToProps = { getUserData };

const mapStateToProps = (state) => ({
  user: state.user,
});

export default connect(mapStateToProps, { getUserData })(
  withStyles(styles)(profile)
);
